/* eslint-disable default-param-last */
export const types = {
  SET_ZONE: 'ADDRESSES/SET_ZONE',
  SET_COVERAGE: 'ADDRESSES/SET_COVERAGE',
  INIT_HORIZONTAL_ADDRESSES: 'ADDRESSES/INIT_HORIZONTAL_ADDRESSES',
  GET_HORIZONTAL_ADDRESSES: 'ADDRESSES/GET_HORIZONTAL_ADDRESSES',
  SET_HORIZONTAL_ADDRESSES: 'ADDRESSES/SET_HORIZONTAL_ADDRESSES',
  GET_HORIZONTAL_ADDRESSES_ERROR: 'ADDRESSES/GET_HORIZONTAL_ADDRESSES_ERROR',
  INIT_VERTICAL_ADDRESSES: 'ADDRESSES/INIT_VERTICAL_ADDRESSES',
  GET_VERTICAL_ADDRESSES: 'ADDRESSES/GET_VERTICAL_ADDRESSES',
  SET_VERTICAL_ADDRESSES: 'ADDRESSES/SET_VERTICAL_ADDRESSES',
  GET_VERTICAL_ADDRESSES_ERROR: 'ADDRESSES/GET_VERTICAL_ADDRESSES_ERROR',
  CLEAR_VERTICAL_ADDRESSES: 'ADDRESSES/CLEAR_VERTICAL_ADDRESSES',
  SET_GMAPS_ADDRESS: 'ADDRESSES/SET_GMAPS_ADDRESS',
};

export const actions = {
  setZone: (data) => ({
    type: types.SET_ZONE,
    payload: { data },
  }),
  setCoverage: (data) => ({
    type: types.SET_COVERAGE,
    payload: { data },
  }),
  initHorizontalAddresses: (data) => ({
    type: types.INIT_HORIZONTAL_ADDRESSES,
    payload: { data },
  }),
  getHorizontalAddresses: (data) => ({
    type: types.GET_HORIZONTAL_ADDRESSES,
    payload: { data },
  }),
  setHorizontalAddresses: (data) => ({
    type: types.SET_HORIZONTAL_ADDRESSES,
    payload: { data },
  }),
  getHorizontalAddressesError: (data) => ({
    type: types.GET_HORIZONTAL_ADDRESSES_ERROR,
    payload: { data },
  }),
  getVerticalAddresses: (data) => ({
    type: types.GET_VERTICAL_ADDRESSES,
    payload: { data },
  }),
  initVerticalAddresses: (data) => ({
    type: types.INIT_VERTICAL_ADDRESSES,
    payload: { data },
  }),
  setVerticalAddresses: (data) => ({
    type: types.SET_VERTICAL_ADDRESSES,
    payload: { data },
  }),
  getVerticalAddressesError: (data) => ({
    type: types.GET_VERTICAL_ADDRESSES_ERROR,
    payload: { data },
  }),
  clearVerticalAddresses: (data) => ({
    type: types.CLEAR_VERTICAL_ADDRESSES,
    payload: { data },
  }),
  setGMapsAddress: (data) => ({
    type: types.SET_GMAPS_ADDRESS,
    payload: { data },
  }),
};

const initialState = {
  zone: null,
  changeZone: false,
  coverage: null,
  horizontalAddresses: null,
  horizontalAddressesLoading: null,
  verticalAddresses: null,
  verticalAddressesLoading: null,
  gmapsAddress: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SET_ZONE: {
      const { data } = { ...action.payload };
      const { zone } = { ...data };
      const { zone: currentZone } = { ...state };
      return {
        ...state,
        zone,
        changeZone: false,
      };
    }
    case types.SET_COVERAGE: {
      const { data } = { ...action.payload };
      const { coverage } = { ...data };
      return {
        ...state,
        coverage,
      };
    }
    case types.INIT_HORIZONTAL_ADDRESSES: {
      return {
        ...state,
      };
    }
    case types.GET_HORIZONTAL_ADDRESSES: {
      const { data } = { ...action.payload };
      return {
        ...state,
        horizontalAddressesLoading: {
          ...state.horizontalAddressesLoading,
          [data.componentName]: true,
        },
        horizontalAddresses: {
          ...state.horizontalAddresses,
        },
      };
    }
    case types.SET_HORIZONTAL_ADDRESSES: {
      const { data } = { ...action.payload };
      return {
        ...state,
        horizontalAddressesLoading: {
          ...state.horizontalAddressesLoading,
          [data.componentName]: false,
        },
        horizontalAddresses: {
          ...state.horizontalAddresses,
          [data.componentName]: data.addresses,
        },
      };
    }
    case types.GET_HORIZONTAL_ADDRESSES_ERROR: {
      const { data } = { ...action.payload };
      return {
        ...state,
        horizontalAddressesLoading: {
          ...state.horizontalAddressesLoading,
          [data.componentName]: false,
        },
      };
    }
    case types.INIT_VERTICAL_ADDRESSES: {
      return {
        ...state,
      };
    }
    case types.GET_VERTICAL_ADDRESSES: {
      const { data } = { ...action.payload };
      return {
        ...state,
        verticalAddressesLoading: {
          ...state.verticalAddressesLoading,
          [data.componentName]: true,
        },
        verticalAddresses: {
          ...state.verticalAddresses,
          [data.componentName]: null,
        },
      };
    }
    case types.SET_VERTICAL_ADDRESSES: {
      const { data } = { ...action.payload };
      return {
        ...state,
        verticalAddressesLoading: {
          ...state.verticalAddressesLoading,
          [data.componentName]: false,
        },
        verticalAddresses: {
          ...state.verticalAddresses,
          [data.componentName]: data.addresses,
        },
      };
    }
    case types.GET_VERTICAL_ADDRESSES_ERROR: {
      const { data } = { ...action.payload };
      return {
        ...state,
        verticalAddressesLoading: {
          ...state.verticalAddressesLoading,
          [data.componentName]: false,
        },
      };
    }
    case types.CLEAR_VERTICAL_ADDRESSES: {
      const { data } = { ...action.payload };
      return {
        ...state,
        verticalAddressesLoading: {
          ...state.verticalAddressesLoading,
          [data.componentName]: false,
        },
        verticalAddresses: {
          ...state.verticalAddresses,
          [data.componentName]: null,
        },
      };
    }
    case types.SET_GMAPS_ADDRESS: {
      const { data } = { ...action.payload };
      const { gmapsAddressData } = data;
      return {
        ...state,
        gmapsAddress: gmapsAddressData,
      };
    }
    default:
      return state;
  }
}

export default reducer;
